import {
  ResearchState,
  HousingCorporation,
  ResearchStateTab,
} from '$src/bootstrap/Store'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Tabs.css'
import {ResearchStateTabs} from '$src/bootstrap/Store'
import Tab from './Tab'
import {v4 as uuid} from 'node-uuid'
import {getSnapshot} from 'mobx-state-tree'

interface Props {
  css?: any
  housingCorporationId: string
  activeTabId?: string
  tabs: typeof ResearchStateTabs.Type
  projectId: string
  projectName: string
  housingCorporation: typeof HousingCorporation.Type
  frozen: boolean
}

interface State {}

export const makeNewEmptyTab = (
  housingCorporation: typeof HousingCorporation.Type,
): typeof ResearchStateTab.SnapshotType => {
  const id = uuid()
  const tab = {
    name: 'Untitled tab',
    id,
    enabled: true,
    query: {
      formValues: {
        values: {
          propertyType: ['rowHouse', 'detachedhouse', 'apartment'],
          municipality: [],
        },
      },
      mapShape: {
        dataType: 'premise',
        type: 'Circle',
        c: getSnapshot(housingCorporation.location),
        radius: 200,
      },
      mapShapeRent: {
        dataType: 'rent',
        type: 'Circle',
        c: getSnapshot(housingCorporation.location),
        radius: 200,
      },
    },
    foundItems: {
      byId: {},
      list: [],
      queried: false,
      selectedIds: {},
      selectedIdsRent: {},
      selectedIdsOldData: {},
    },
  }

  return tab
}

@observer
export default class Tabs extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  addTab = () => {
    if (this.props.frozen) return
    this.props.tabs.add(makeNewEmptyTab(this.props.housingCorporation))
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)
    const {tabs} = props
    const activeTab = props.activeTabId && tabs.byId.get(props.activeTabId)

    const activeTabId = (activeTab && activeTab.id) || tabs.list[0].id

    return (
      <div {...classes('container')}>
        {tabs.list.map(tab => {
          const isActive = tab.id === activeTabId
          return (
            <Tab
              tabStoreState={tab}
              tabsStoreState={tabs}
              isActive={isActive}
              key={`tab-${tab.id}`}
              housingCorporationId={props.housingCorporationId}
              projectId={props.projectId}
              projectName={props.projectName}
              frozen={props.frozen}
            />
          )
        })}
        {!props.frozen && (
          <a {...classes('addTab')} href="#" onClick={this.addTab}>
            +
          </a>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/comparableSales/Tabs.tsx